export default "__VITE_ASSET__BtO$r134__"